import apolloClient from "../apolloClient";
import { cartStatusTypes } from "utils";
import {
	FIND_CART,
	CREATE_CART,
	ADD_CART_ITEM,
	UPDATE_CART_ITEM,
	REMOVE_CART_ITEM,
	GET_CART_ITEMS,
} from "./graphql";

class CartService {
	async find(customerToken) {
		const response = await apolloClient.query({
			query: FIND_CART,
			variables: { customerToken, status: cartStatusTypes.OPEN },
		});
		const { nodes } = response.data.carts;
		if (nodes.length) {
			const { id, checkoutId, cartItems } = nodes[0];
			return {
				id,
				checkoutId,
				lineItems: cartItems.nodes,
			};
		}
		return null;
	}

	async create(cart) {
		const response = await apolloClient.mutate({
			mutation: CREATE_CART,
			variables: { cart },
		});
		return response.data.createCart.cart;
	}

	async addItem(cartLineItem, cartId) {
		const { productId, variantId, quantity } = cartLineItem;
		const cartItem = {
			cartId,
			productId,
			variantId,
			quantity,
		};
		const response = await apolloClient.mutate({
			mutation: ADD_CART_ITEM,
			variables: { cartItem },
		});
		const { cartItem: item } = response.data.createCartItem;
		return item.id;
	}

	async updateItem(lineItem) {
		const cartItem = {
			id: lineItem.id,
			patch: { quantity: lineItem.quantity },
		};
		return await apolloClient.mutate({
			mutation: UPDATE_CART_ITEM,
			variables: { cartItem },
		});
	}

	async removeItem(cartItemId) {
		return await apolloClient.mutate({
			mutation: REMOVE_CART_ITEM,
			variables: { cartItemId },
		});
	}

	async fetchLineItems(cartId) {
		const response = await apolloClient.query({
			query: GET_CART_ITEMS,
			variables: { cartId },
		});
		const { nodes } = response.data.cartItems;
		return nodes;
	}
}

export default new CartService();
